import EastIcon from '@mui/icons-material/East';
import { ReactElement } from 'react';

import { Brand } from '../types/brand.types';
import i18n from './i18n';

export const getBrandSearchSuggestions = (brands: Brand[], searchKeyWord: string): Brand[] => {
  if (!brands || !brands.length || !searchKeyWord) {
    return [];
  }

  return brands.filter((brand) => brand.name?.toLowerCase().startsWith(searchKeyWord.toLowerCase()));
};

export const getBrandSuggestionTitle = (brandSuggestion: Brand, searchKeyWord?: string): ReactElement => {
  const brandTitle = brandSuggestion?.name;
  const brandTitleHighlighted = brandTitle.replace(new RegExp(searchKeyWord, 'ig'), (match) => `<b>${match}</b>`);

  return (
    <>
      <span className="top-category">{i18n.t('common.brand')}</span>
      <EastIcon />
      <span className="category" dangerouslySetInnerHTML={{ __html: brandTitleHighlighted }} />
    </>
  );
};
